import angular from 'angular';
import eSignDocument from './eSignDocument';

export default angular
  .module('components.eSignDocument', [])
  .component('eSignDocument', eSignDocument).name;
